/**
 * Lời gọi API cho MH-15 Kho âm thanh, đúng hình dạng của
 * `apps/api/src/kho-am-thanh/kho-am-thanh.controller.ts`.
 */
import { layToken, type PhongBiNoiBo } from './khach-api';
import { chuoiTruyVan, goi, LoiApi } from './goi-chung';
import type { TrangDuLieu } from './thiet-bi-api';

export interface DongAudioAsset {
  id: string;
  ten: string;
  nhom: string | null;
  the: string[];
  dinhDang: string;
  thoiLuongGiay: number | null;
  kichThuocByte: number | null;
  soThamChieu: number;
  createdAt: string;
  urlTaiVe: string;
}

export interface BoLocAudioAsset {
  page?: number;
  pageSize?: number;
  keyword?: string;
  nhom?: string;
  the?: string;
}

function goc(): string {
  return (import.meta.env?.VITE_API_BASE_URL as string | undefined) ?? '';
}

export const khoAmThanhApi = {
  danhSach: (tham: BoLocAudioAsset, signal?: AbortSignal): Promise<TrangDuLieu<DongAudioAsset>> =>
    goi(`/api/v1/audio-assets${chuoiTruyVan(tham as Record<string, string | number | undefined>)}`, {
      signal,
    }),

  soThamChieu: (id: string, signal?: AbortSignal): Promise<{ soThamChieu: number }> =>
    goi(`/api/v1/audio-assets/${id}/references`, { signal }),

  xoa: (id: string): Promise<{ id: string }> => goi(`/api/v1/audio-assets/${id}`, { phuongThuc: 'DELETE' }),

  /** Tải lên dùng `FormData` trực tiếp: điểm cuối nhận multipart, khác các điểm cuối khác. */
  taiLen: async (tep: File, meta: { ten?: string; nhom?: string; the?: string }): Promise<{ id: string }> => {
    const than = new FormData();
    than.append('file', tep);
    if (meta.ten) than.append('ten', meta.ten);
    if (meta.nhom) than.append('nhom', meta.nhom);
    if (meta.the) than.append('the', meta.the);
    const token = layToken();
    const res = await fetch(`${goc()}/api/v1/audio-assets`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: than,
    });
    const pb = (await res.json()) as PhongBiNoiBo<{ id: string }>;
    if (!pb.success) throw new LoiApi(pb.code, pb.message, pb.requestId);
    return pb.data as { id: string };
  },
};
